'use es6';

import EditorActionsAndEventsContext from 'ContentEditorUI/context/EditorActionsAndEventsContext';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withEditorActionsAndEvents(WrappedComponent) {
  const WrapperComponentWithContext = props => {
    const editorActionsAndEvents = useContext(EditorActionsAndEventsContext);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      bus: editorActionsAndEvents.bus,
      saveActions: editorActionsAndEvents.saveActions
    }));
  };
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WrapperComponentWithContext.displayName = `ComponentWithEditorActionsAndEvents(${displayName})`;
  return WrapperComponentWithContext;
}